<script setup lang="ts">
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@/components/ui/hover-card"

interface Member {
  id: number
  name: string
  email?: string
}

defineProps<{
  name: string
  members?: Member[]
}>()
</script>

<template>
  <HoverCard>
    <HoverCardTrigger as-child>
      <slot />
    </HoverCardTrigger>
    <HoverCardContent class="w-56">
      <div class="space-y-2">
        <p class="text-sm font-semibold">{{ name }}</p>
        <ul v-if="members && members.length > 0" class="space-y-1">
          <li
            v-for="member in members"
            :key="member.id"
            class="text-xs text-muted-foreground"
          >
            {{ member.name || member.email || "---" }}
          </li>
        </ul>
        <p v-else class="text-xs text-muted-foreground">Sin miembros</p>
      </div>
    </HoverCardContent>
  </HoverCard>
</template>
